import { IStartUpAppSettings } from '../model';

export const appSettings: IStartUpAppSettings = {
  cdnBaseUrlAddress: process.env.CdnBaseAddress ?? '',
  checkoutGatewayBaseUrlAddress: 'api/checkout',
  applicationName: process.env.ReleaseName ?? '',
  environment: process.env.RunningEnvironment ?? '',
  przelewyPaymentAddress: process.env.PrzelewyPaymentAddress ?? '',
  googleApiKey: process.env.GoogleApiKey ?? '',
  mapyCzApiKey: process.env.MapyCzApiKey ?? '',
  newRelicLicenseKey: process.env.NewRelicLicenseKey ?? '',
  newRelicAppId: process.env.NewRelicAppId ?? '',
  newRelicAccountId: process.env.NewRelicAccountId ?? '',
};

export const enableRequestInterception = false;
